import type { DraftData, ObjetoProjeto } from './types';
import { salvarRascunho, carregarRascunho } from './db';
import { getObjetivosGeraisHTML, getObjetivosEspecificosHTML } from './editor';
import { getAtividades } from './activities';
import { getIdentificacao } from './partners';
import { atualizarChecklistObjeto } from './progress';

const DEFAULT_DRAFT: DraftData = {
  objetivosGerais: '',
  objetivosEspecificos: '',
  justificativa: '',
  responsabilidadesUFC: '',
  responsabilidadesParceiro: '',
  atividadesConjuntas: '',
  direitosPI: '',
  atividades: [],
  meios: [],
  recursosFinanceiros: '',
  infraestrutura: '',
  tabelas_orcamento: []
};

function typedKeys<T extends object>(obj: T) {
  return Object.keys(obj) as Array<keyof T>;
}

const IDS: Record<keyof ObjetoProjeto, string> = {
  tituloProjeto: 'tituloProjeto',
  tipoProjeto: 'tipoProjeto',
  areaConhecimento: 'areaConhecimento'
};

function input(id: string): HTMLInputElement | null {
  return document.getElementById(id) as HTMLInputElement | null;
}

export function getObjetoProjeto(): ObjetoProjeto {
  return {
    tituloProjeto: input(IDS.tituloProjeto)?.value || '',
    tipoProjeto: input(IDS.tipoProjeto)?.value || '',
    areaConhecimento: input(IDS.areaConhecimento)?.value || ''
  };
}

async function persistir() {
  const atual: DraftData =
    (await carregarRascunho()) || DEFAULT_DRAFT;

  const objeto = getObjetoProjeto();
  const id = getIdentificacao();
  const atividades = getAtividades();
  const objetivosGerais = getObjetivosGeraisHTML();
  const objetivosEspecificos = getObjetivosEspecificosHTML();

  const novo: DraftData = {
    ...atual,
    ...id,
    ...objeto,
    atividades,
    objetivosGerais,
    objetivosEspecificos
  };

  await salvarRascunho(novo);

  atualizarChecklistObjeto(
    novo.tituloProjeto,
    novo.tipoProjeto,
    novo.areaConhecimento
  );
}

function wire(id: string) {
  input(id)?.addEventListener('input', () => {
    void persistir();
  });
}

export function initObjetoProjeto() {
  for (const id of Object.values(IDS)) wire(id);
}

export function preencherObjetoProjeto(data: Partial<DraftData>) {
  for (const k of typedKeys(IDS)) {
    const el = input(IDS[k]);
    const v = (data as Partial<Record<keyof ObjetoProjeto, string>>)[k];

    if (!el) continue;

    if (
      k === 'tipoProjeto' &&
      (el.hasAttribute('readonly') || el.hasAttribute('data-fixed') || el.hasAttribute('data-skip-reset'))
    ) {
      if (!el.value) {
        el.value = el.getAttribute('value') || 'Pesquisa';
      }
      continue; 
    }

    if (typeof v === 'string') {
      el.value = v;
    }
  }

  const obj = getObjetoProjeto();
  atualizarChecklistObjeto(obj.tituloProjeto, obj.tipoProjeto, obj.areaConhecimento);
}